import { render } from "./WildBookEntryAnimal.vue?vue&type=template&id=f6349746&scoped=true&ts=true"
import script from "./WildBookEntryAnimal.vue?vue&type=script&lang=ts"
export * from "./WildBookEntryAnimal.vue?vue&type=script&lang=ts"

import "./WildBookEntryAnimal.vue?vue&type=style&index=0&id=f6349746&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6349746"]])

export default __exports__